export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";